<template>
    <div class="card border border-secondary">
        <div class="card-header border-bottom-0 p-1">
            <b-form-input v-model="search" type="text" name="search" slot="header"></b-form-input>
        </div>
        <table class="table mb-0" v-if="types.length > 0">
            <tbody>
                <tr v-for="type in filteredTypes" :key="type.key">
                    <td class="p-0" :class="{'bg-light': type.key == expanded}">
                        <div class="d-flex">
                            <div class="p-2" :class="{'font-weight-bold': type.key == expanded}">
                                <span v-html="highlight(type.name)"></span>
                            </div>
                            <div class="p-1 ml-auto">
                                <button class="btn btn-sm btn-danger" v-if="type.key == expanded" @click.prevent="expanded = null">
                                    <i class="fas fa-fw fa-times"></i>
                                </button>
                                <button class="btn btn-sm btn-secondary" v-else @click.prevent="expanded = type.key">
                                    <i class="fas fa-fw fa-pencil-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row no-gutters pl-1 pr-1 pb-1" v-if="type.key == expanded">
                            <div class="col-md-6 p-1" v-for="(section, i) in type.sections" :key="i">
                                <div class="card mb-0 h-100">
                                    <div class="card-body pt-2 pb-2 pl-3 pr-3">
                                        <div class="d-flex pt-1 pb-1" v-for="(permission, j) in section" :key="j">
                                            <div class="pt-1">
                                                <span v-html="highlight(permission.value)"></span>
                                            </div>
                                            <div class="ml-auto">
                                                <div class="btn-group btn-group-sm border border-secondary">
                                                    <label class="btn mb-0" :class="[checked(type.key, permission.key, enums.PermisionState.Deny) ? 'btn-secondary' : 'btn-light']" @click="check(type.key, permission.key, enums.PermisionState.Deny)">
                                                        <i class="fas fa-fw fa-times" :title="$t('[[[Zabierz dostęp]]]')"></i>
                                                    </label>
                                                    <label class="btn mb-0" :class="[checked(type.key, permission.key, null) ? 'btn-secondary' : 'btn-light']" @click="check(type.key, permission.key, null)">
                                                        <i class="fas fa-fw fa-minus" :title="$t('[[[Dostęp niezdefiniowany]]]')"></i>
                                                    </label>
                                                    <label class="btn mb-0" :class="[checked(type.key, permission.key, enums.PermisionState.Allow) ? 'btn-secondary' : 'btn-light']" @click="check(type.key, permission.key, enums.PermisionState.Allow)">
                                                        <i class="fas fa-fw fa-check" :title="$t('[[[Przyznaj dostęp]]]')"></i>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pl-2 pr-2 pb-2" v-else-if="visible(type).length > 0">
                            <span class="d-inline-block small pr-3" v-for="item in visible(type)" :key="item.value">
                                <i class="fas fa-fw fa-check text-success" :title="$t('[[[Dostęp przyznany]]]')" v-if="checked(type.key, item.key, enums.PermisionState.Allow)"></i>
                                <i class="fas fa-fw fa-times text-danger" :title="$t('[[[Dostęp zabroniony]]]')" v-if="checked(type.key, item.key, enums.PermisionState.Deny)"></i>
                                <span v-html="highlight(item.value)"></span>
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="card-body text-center border-top border-secondary" v-else>
            {{ $t('[[[Brak wyników]]]') }}
        </div>
    </div>
</template>

<script>
import PermissionsService from '@/services/core/PermissionsService';

let PermisionState = {
    Allow: 'Allow',
    Deny: 'Deny'
};

export default {
    name: 'permissions',
    components: {
    },
    props: {
        'value': {
            default: () => [],
            type: Array
        }
    },
    data()
    {
        return {
            enums: {
                PermisionState: PermisionState
            },
            search: '',
            expanded: null,
            types: [],
            permissions: []
        };
    },
    async mounted()
    {
        try
        {
            let response = await PermissionsService.getList();

            this.types = response.data;
        }
        catch (ex)
        {
            this.$log.debug(ex);
        }
    },
    computed: {
        filteredTypes()
        {
            return this.types.filter(p =>
                p.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                p.sections
                    .reduce((p, q) => p.concat(q))
                    .filter(q =>
                        q.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
                    )
                    .length > 0
            );
        }
    },
    methods: {
        check(type, value, mode)
        {
            let item = { key: type, value: {} };
            let permissions = this.value.slice();
            let result = permissions.filter(p => p.key === type);

            if (result.length === 0)
            {
                permissions.push(item);
            }
            else
            {
                item = result[0];
            }

            if (mode == null && item.value.hasOwnProperty(value))
            {
                delete item.value[value];
            }
            if (mode != null)
            {
                item.value[value] = mode;
            }

            this.$emit('input', permissions.filter(p => Object.keys(p.value).length > 0));
        },
        checked(type, value, mode)
        {
            return mode != null
                ? this.value.filter(p => p.key === type && p.value.hasOwnProperty(value) && p.value[value] === mode).length > 0
                : this.value.filter(p => p.key === type && p.value.hasOwnProperty(value)).length === 0;
        },
        visible(type)
        {
            return type.sections.reduce((p, q) => p.concat(q)).filter(p => !this.checked(type.key, p.key, null));
        },
        highlight: function(text)
        {
            if (this.search.length > 0)
            {
                return text.replace(new RegExp(`(${this.search})`, 'ig'), (match, p1) => `<b>${p1}</b>`);
            }
            return text;
        }
    }
};
</script>
